import {Button, Result} from 'antd';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {PageRoute} from '@/constants';
import {i18nKey} from '@/locales/i18n';
import {TitlePage} from '@/components/TitlePage';
import style from './style.module.scss';

const NotFoundPage = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={style.wrapperNotFound}>
      <TitlePage title={t(i18nKey.metaTitle.page404)}>
        <Result
          status="404"
          title="404"
          subTitle={t(i18nKey.notFoundScreen.titleNotFound)}
          extra={
            <Button type="primary" onClick={() => navigate(PageRoute.HOME)}>
              {t(i18nKey.notFoundScreen.txtButtonBack)}
            </Button>
          }
        />
      </TitlePage>
    </div>
  );
};

export default NotFoundPage;
